/**
 * @generated SignedSource<<f61da684b730368fe8d049568e14fb89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "anonymous"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "anonymous",
        "variableName": "anonymous"
      },
      {
        "kind": "Variable",
        "name": "contributionId",
        "variableName": "contributionId"
      }
    ],
    "concreteType": "ToggleContributionAnonymousModePayload",
    "kind": "LinkedField",
    "name": "toggleContributionAnonymousMode",
    "plural": false,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "needsAuthentication",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ValidationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "field",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "messages",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "MutationResult",
        "abstractKey": "__isMutationResult"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Contribution",
        "kind": "LinkedField",
        "name": "contribution",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fromAnonymous",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ToggleContributionAnonymousModeMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ToggleContributionAnonymousModeMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "916f5110df96017febdc1b61daa40ecf",
    "id": null,
    "metadata": {},
    "name": "ToggleContributionAnonymousModeMutation",
    "operationKind": "mutation",
    "text": "mutation ToggleContributionAnonymousModeMutation(\n  $contributionId: ID!\n  $anonymous: Boolean!\n) {\n  toggleContributionAnonymousMode(contributionId: $contributionId, anonymous: $anonymous) {\n    ... on MutationResult {\n      __isMutationResult: __typename\n      success\n      notice\n      needsAuthentication\n      errors {\n        field\n        messages\n      }\n    }\n    contribution {\n      id\n      fromAnonymous\n    }\n  }\n}\n"
  }
};
})();

node.hash = "33bbdcfa0a6a4d228f7468129581921f";

module.exports = node;
